"use strict";

var React = require("react");

var SvgIconMove = function SvgIconMove() {
  return /*#__PURE__*/ React.createElement(
    "svg",
    {
      width: "1em",
      height: "1em",
      viewBox: "0 0 18 18",
      fill: "none",
    },
    /*#__PURE__*/ React.createElement("path", {
      d:
        "M8.94.003a.546.546 0 00-.323.154L6.162 2.61a.545.545 0 10.767.776l1.526-1.526v6.597H1.858l1.526-1.525a.546.546 0 10-.767-.776L.162 8.612a.546.546 0 000 .775l2.455 2.455a.546.546 0 10.767-.776L1.858 9.55h6.597v6.589l-1.526-1.526a.546.546 0 10-.767.776l2.455 2.454a.545.545 0 00.767 0l2.455-2.454a.545.545 0 10-.768-.776l-1.525 1.526V9.549h6.597l-1.526 1.518a.546.546 0 10.767.775l2.455-2.455a.547.547 0 000-.775l-2.455-2.455a.546.546 0 10-.767.776l1.526 1.525H9.546V1.861l1.526 1.526a.546.546 0 10.767-.776L9.384.157a.546.546 0 00-.443-.154z",
      fill: "#363636",
    })
  );
};

exports["foreignIcon"] = SvgIconMove;
